import React from 'react';
import { CardSelect, Text } from '@nerdwallet/currency';
import classes from '@nerdwallet/base-styles/classes';
import PropTypes from 'prop-types';

const CardSelectFields = ({ onChange, value, options, keyValue, label }) => {
  return (
    <div className={classes('padding-vertical-3')}>
      <div className={classes('margin-bottom-2')}>
        <Text>{label}</Text>
      </div>
      <CardSelect
        onChange={(v) => onChange(keyValue, v)}
        options={options?.map((item) => ({
          label: <Text>{item.label}</Text>,
          value: item.value,
        }))}
        value={value}
      />
    </div>
  );
};

CardSelectFields.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  options: PropTypes.object,
  keyValue: PropTypes.string,
  label: PropTypes.string,
};

CardSelectFields.defaultProps = {
  options: [],
};

export default CardSelectFields;
